export default "__VITE_ASSET__D_nSOwUW__"